export default {
  nav: {
    home: "Accueil",
    lab: "Atelier réparation",
    phones: "Téléphones",
    showroom: "Boutique",
    visit: "Visite & Contact",
    getEstimate: "Estimation",
    openMenu: "Ouvrir le menu",
    closeMenu: "Fermer le menu",
    menu: "Menu",
    sound: "Son",
    call: "Appeler",
    tagline: "Réparation téléphone · Calgary",
  },
  status: {
    openNow: "Ouvert",
    closed: "Fermé",
    until: "jusqu'à",
    opensToday: "ouvre aujourd'hui à",
    opensTomorrow: "ouvre demain à",
    opensSunday: "ouvre dimanche à",
  },
  hero: {
    h1a: "Votre techno brisée,",
    h1b: "soigneusement",
    h1c: "remise à neuf.",
    sub: "Next-G Phone Repair répare téléphones, portables et appareils du quotidien sur un vrai établi à Calgary — des réponses franches, un travail soigné, et rien ne commence sans votre accord.",
    ctaQuote: "Obtenir une estimation",
    ctaVisit: "Visiter la boutique",
    est: "Calgary, AB",
    badge: "Achat & Réparation",
  },
  marquee: [
    "Réparation d'écran", "Remplacement de batterie", "Ports de charge", "Dégâts d'eau",
    "Modules caméra", "Récupération de données", "Soin des portables", "Sauvetage logiciel",
  ],
  process: {
    chapter: "01",
    eyebrow: "Notre façon de faire",
    title: "Quatre étapes. Sans mystère, sans pression.",
    lede: "Chaque réparation chez Next-G suit le même rythme honnête — vous savez toujours ce qui arrive à votre appareil et combien cela coûtera.",
    steps: [
      { num: "01", title: "Apportez-le", body: "Passez avec l'appareil tel quel — sans rendez-vous, sans emballage, sans formulaire. S'il est mouillé, laissez-le éteint et venez directement." },
      { num: "02", title: "On diagnostique", body: "On l'ouvre, on teste le matériel et on vous explique en langage simple ce qui a réellement lâché — et ce qui va bien. Pas de jargon, pas de devinettes." },
      { num: "03", title: "Vous approuvez", body: "Vous recevez un prix clair en CAD avant tout travail. Rien ne commence sans votre accord — et si ça ne vaut pas la peine, on vous le dit aussi." },
      { num: "04", title: "De retour entre vos mains", body: "On répare, on reteste chaque fonction, et on vous remet l'appareil fonctionnel — avec l'ancienne pièce si vous voulez la voir." },
    ],
  },
  highlights: {
    chapter: "02",
    eyebrow: "Ce qu'on répare",
    title: "Téléphones, portables et tout ce dont vous dépendez chaque jour.",
    items: [
      { title: "Réparation téléphone", body: "Écrans, batteries, ports, caméras et dégâts d'eau pour iPhone et Android." },
      { title: "Réparation portable", body: "MacBook et portables Windows — réparations matérielles, mises à niveau et systèmes lents." },
      { title: "Support logiciel", body: "Boucles de démarrage, mises à jour ratées, plantages et problèmes de compte réglés calmement." },
      { title: "Diagnostic d'appareil", body: "Vous ne savez pas ce qui cloche? Une inspection à l'établi vous dit exactement ce qui se passe." },
      { title: "Boutique d'accessoires", body: "Étuis, protecteurs, chargeurs, audio et équipement de créateur — ajustés en boutique." },
    ],
  },
  teaser: {
    chapter: "03",
    eyebrow: "Estimation en une minute",
    titleA: "Choisissez le problème.",
    titleEm: "Puis appelez",
    titleB: "— on vous chiffre ça au téléphone.",
    body: "Choisissez l'appareil et le problème — puis appelez la boutique avec ces détails pour un prix franc et honnête, tout de suite.",
    steps: ["Choisissez l'appareil", "Choisissez le problème", "Appelez avec les détails"],
    ctaStart: "Commencer l'estimation",
    ctaCall: "Appeler",
    pricesLabel: "Des prix de départ honnêtes",
    prices: ["Toute réparation dès 79 $ CA", "Écrans, batteries, ports, caméras et plus", "Inspection gratuite, toujours"],
  },
  location: {
    chapter: "04",
    eyebrow: "Trouver la boutique",
    titleEm: "— à côté de la TD Bank.",
    lede: "Les visites sans rendez-vous sont bienvenues. Apportez l'appareil tel quel, on s'occupe du reste.",
    openMaps: "Ouvrir dans Maps",
    visitContact: "Visite & contact",
  },
  lab: {
    chapter: "L'atelier réparation",
    eyebrow: "Services",
    titleA: "Chaque réparation, expliquée en",
    titleEm: "langage simple.",
    lede: "Touchez un service pour voir ce qu'il couvre et les symptômes qu'il règle. Demander une estimation est toujours gratuit — et le travail est toujours approuvé par vous avant de commencer.",
    notice: "Vous remarquez peut-être",
    ask: "Demander une estimation",
    pricingTitle: "Comment fonctionnent nos prix",
    pricingBody: "Les fourchettes en ligne sont des repères préliminaires en CAD. Le prix final est confirmé après inspection de l'appareil, identification du modèle exact et vérification des pièces — et le travail ne commence qu'avec votre accord.",
    ctaTitleA: "Pas sûr du bon service?",
    ctaTitleEm: "Demandez-nous.",
    ctaBody: "Décrivez ce que fait l'appareil — on vous indique la bonne réparation.",
    ctaQuote: "Obtenir une estimation",
    ctaCall: "Appeler",
    services: {
      screen: {
        title: "Réparation d'écran brisé",
        blurb: "Vitre fissurée, pixels morts, lignes sur l'écran ou tactile qui ne répond plus. On remplace les écrans de téléphones, tablettes et portables avec des pièces de qualité équivalente.",
        symptoms: ["Vitre fissurée ou brisée", "Le tactile ne répond plus", "Lignes, taches ou zones noires", "Écran noir mais le téléphone vibre"],
      },
      battery: {
        title: "Remplacement de batterie",
        blurb: "Si votre téléphone meurt à 30 %, s'éteint au froid ou vit sur un chargeur, une batterie neuve règle généralement tout. Santé vérifiée avant et après.",
        symptoms: ["La batterie se vide en quelques heures", "Extinctions aléatoires", "Batterie gonflée qui soulève l'écran", "Ne fonctionne que branché"],
      },
      charging: {
        title: "Problèmes de port de charge",
        blurb: "Câbles lâches, charge lente ou un téléphone qui ne charge qu'à un certain angle. On nettoie, répare ou remplace les ports de charge et on trace les pannes d'alimentation jusqu'à la carte mère.",
        symptoms: ["Le câble est lâche ou tombe", "Ne charge qu'à un certain angle", "Ne charge plus du tout", "La charge sans fil marche, pas le port"],
      },
      backglass: {
        title: "Vitre arrière & boîtier endommagés",
        blurb: "Une vitre arrière fissurée et un cadre tordu, ce n'est pas qu'esthétique — la poussière et l'humidité s'y infiltrent. On remplace la vitre arrière et on restaure le boîtier pour sceller l'appareil.",
        symptoms: ["Vitre arrière fissurée ou brisée", "Bords coupants au toucher", "Cadre tordu ou bosselé", "Anneau de caméra lâche ou qui tremble"],
      },
      camera: {
        title: "Remplacement & réparation de caméra",
        blurb: "Photos floues, lentille qui tremble, mise au point capricieuse ou appareil photo qui affiche du noir. On remplace lentilles et modules caméra, avant et arrière.",
        symptoms: ["Photos toujours floues", "La caméra tremble ou cliquette", "Écran noir dans l'app photo", "Lentille fissurée"],
      },
      water: {
        title: "Évaluation des dégâts d'eau",
        blurb: "Du liquide dans un appareil, c'est une course contre la corrosion. Apportez-le éteint — on l'ouvre, on nettoie la corrosion et on évalue ce qui peut être sauvé avant tout devis.",
        symptoms: ["Tombé dans l'eau ou éclaboussé", "Écran qui clignote après l'eau", "Téléphone mort après un liquide", "Humidité sous la caméra ou l'écran"],
      },
      software: {
        title: "Logiciels, plantages & démarrage",
        blurb: "Coincé sur le logo, mise à jour ratée, plantages constants ou compte bloqué. On règle les problèmes logiciels, on restaure les systèmes et on vous aide à rentrer dans votre appareil.",
        symptoms: ["Coincé sur le logo de démarrage", "Mise à jour ratée, ne démarre plus", "Les apps plantent constamment", "Bloqué hors de vos comptes"],
      },
      data: {
        title: "Récupération de données & accès",
        blurb: "Photos, contacts et fichiers piégés sur un appareil mort ou brisé. On récupère les données des téléphones et portables quand le matériel le permet — même si l'appareil ne s'allume plus.",
        symptoms: ["L'appareil ne s'allume plus mais les données comptent", "Photos ou fichiers piégés sur un téléphone brisé", "Code d'accès oublié", "Disque de portable défaillant"],
      },
      laptop: {
        title: "Support matériel & logiciel portable",
        blurb: "Écrans, claviers, batteries, stockage, systèmes lents et nettoyage de virus — MacBook et Windows reçoivent le même soin que les téléphones.",
        symptoms: ["Écran de portable fissuré", "Touches mortes ou frappes erronées", "Portable soudainement très lent", "Ne charge plus ou ne tient plus la charge"],
      },
      diagnostics: {
        title: "Diagnostic & consultation",
        blurb: "Vous ne savez pas ce qui cloche? Apportez-le. On inspecte l'appareil, on vous explique clairement ce qui se passe, et on chiffre la réparation avant tout travail.",
        symptoms: ["Quelque chose cloche sans savoir quoi", "Deuxième avis sur le devis d'un autre atelier", "Vieil appareil — ça vaut le coup?", "Plusieurs problèmes à la fois"],
      },
      cleaning: {
        title: "Nettoyage en profondeur",
        blurb: "Peluches de poche, poussière et saleté bouchent lentement haut-parleurs, ports et boutons. On ouvre l'appareil pour un nettoyage complet, dedans et dehors — ça règle souvent le son étouffé et les boutons collants.",
        symptoms: ["Haut-parleurs étouffés ou faibles", "Port de charge plein de peluches", "Boutons collants ou coincés", "Poussière sous la vitre de la caméra"],
      },
    },
  },
  fixboth: {
    eyebrow: "Téléphones & portables",
    title: "Téléphone cassé. Portable cassé. Un seul arrêt.",
    steps: [
      "iPhone 17 Pro Max — écran et vitre arrière fissurés",
      "Portables Windows — HP, Dell et plus",
      "MacBook — écrans, batteries, claviers",
      "Repartez avec un appareil comme neuf",
    ],
    cta: "Obtenir une estimation",
  },
  buy: {
    shopLink: "Voir les téléphones",
    eyebrow: "Téléphones neufs & usagés",
    titleA: "Acheter &",
    titleEm: "Réparer",
    titleB: "— une boutique, les deux.",
    lede: "Nous vendons des téléphones neufs et usagés — Samsung, iPhone et Google Pixel — tous testés, activés et prêts à l'emploi. Usagé veut dire excellent état, sans exception.",
    perks: [
      { title: "Garantie 6 à 12 mois", body: "Chaque téléphone est couvert de 6 mois jusqu'à un an complet." },
      { title: "Protecteur + étui offerts", body: "Un protecteur d'écran trempé de qualité et un étui offerts avec chaque téléphone acheté." },
      { title: "Rabais fidélité", body: "Chaque achat vous ajoute à nos rabais futurs — plus vous revenez, plus vous économisez." },
      { title: "Testé & activé", body: "Entièrement testé, activé et prêt à l'emploi dès votre sortie." },
    ],
    bestPrice: "Les meilleurs prix de téléphones à Calgary & Edmonton — franchement, dans tout l'Alberta.",
    brandsTitle: "Ce que nous avons",
    seriesNote: "…et plus en boutique. Appelez pour le stock du jour.",
    cta: "Appelez pour le stock",
    iphoneLine: "iPhone 5 et plus",
    pixelLine: "Pixel 6 et plus",
  },
  showroom: {
    chapter: "La boutique",
    eyebrow: "Accessoires & techno du quotidien",
    titleA: "Une petite étagère",
    titleEm: "soigneusement choisie",
    titleB: "— pas un entrepôt.",
    lede: "Étuis, protection, alimentation et audio, choisis pour la vie de tous les jours. Tout peut être ajusté ou testé sur votre appareil au comptoir.",
    groups: { all: "Tout", phones: "Téléphones", protection: "Protection", power: "Alimentation", audio: "Audio", wearables: "Montres", car: "Auto", studio: "Studio" },
    availability: "Disponibilité et prix confirmés en boutique",
    stripEyebrow: "Venez voir en personne",
    stripTitle: "L'étagère change souvent — flâner ne coûte rien.",
    stripVisit: "Planifier votre visite",
    stripQuote: "Obtenir une estimation",
    items: {
      phones: { title: "Téléphones neufs & usagés", blurb: "Samsung, iPhone et Google Pixel — testés, activés et prêts à l'emploi, avec 6 mois à un an de garantie." },
      cases: { title: "Étuis de téléphone", blurb: "Étuis minces, robustes et transparents ajustés à votre modèle exact — essayez-les en boutique." },
      protectors: { title: "Protecteurs & protection caméra", blurb: "Verre trempé et filtre de confidentialité, plus protection d'objectif — installés au comptoir pendant que vous attendez." },
      cables: { title: "Câbles & chargeurs rapides", blurb: "Câbles tressés USB-C et Lightning, plus des chargeurs rapides de qualité pour iPhone, Android et tablettes." },
      power: { title: "Batteries externes & chargeurs", blurb: "Chargeurs muraux rapides, chargeurs sans fil, hubs multiprises et batteries externes pour les voyages." },
      car: { title: "Gadgets auto", blurb: "Supports et fixations de téléphone, plus chargeurs de voiture filaires et sans fil pour chaque appareil." },
      audio: { title: "AirPods & écouteurs", blurb: "AirPods, écouteurs sans fil et casques — l'écoute quotidienne, réglée." },
      speakers: { title: "Mini enceintes sans fil", blurb: "Enceintes portables prêtes pour l'extérieur, avec un gros son dans un petit format." },
      smartwatches: { title: "Montres connectées abordables", blurb: "Des montres du quotidien qui mesurent le rythme cardiaque, comptent les pas et se connectent à votre téléphone." },
      memory: { title: "Cartes mémoire", blurb: "Cartes microSD de toutes capacités, pour téléphones, caméras et tablettes." },
      keyboards: { title: "Claviers", blurb: "Claviers filaires et sans fil pour le travail, les études et le jeu." },
      creatorkit: { title: "Kits de création de contenu", blurb: "Anneaux lumineux, trépieds portables et sur pied, et bien plus pour les créateurs." },
      creator: { title: "Équipement créateur & télétravail", blurb: "Trépieds, supports, anneaux lumineux et petites améliorations de bureau pour appels, cours et contenu." },
      addons: { title: "Accessoires téléphone & portable", blurb: "Supports, pochettes, hubs et les petites choses qui rendent votre appareil plus agréable au quotidien." },
      preowned: { title: "Appareils & pièces de rechange", blurb: "Demandez au comptoir les appareils et pièces de rechange actuellement en rayon." },
    },
  },
  visit: {
    chapter: "Visite & Contact",
    eyebrow: "Passez nous voir",
    titleA: "La boutique sur 17th Ave SE,",
    titleEm: "juste à côté de la TD Bank.",
    lede: "Les visites sans rendez-vous sont bienvenues pendant les heures d'ouverture. Apportez l'appareil tel quel — aucun rendez-vous nécessaire.",
    addressLabel: "Adresse",
    hoursLabel: "Heures d'ouverture",
    call: "Appeler",
    text: "Texter la boutique",
    email: "Nous écrire",
    openMaps: "Ouvrir dans Maps",
    planEyebrow: "Vous préférez planifier?",
    planTitle: "Obtenez une estimation préliminaire avant de vous déplacer.",
    planCta: "Obtenir une estimation",
    mapTitle: "Carte vers Next-G Phone Repair",
  },
  quote: {
    eyebrow: "Estimation de réparation",
    titleA: "Un chiffre clair,",
    titleEm: "en une minute environ.",
    lede: "Trois choix rapides nous disent ce qui se passe. Ensuite, appelez — on vous donne un prix clair au téléphone, approuvé par vous avant tout travail.",
    step: "Étape",
    of: "sur",
    stepTitle1: "Qu'est-ce qu'on répare?",
    stepTitle2: "Quelle génération, à peu près?",
    stepTitle3: "Qu'est-ce qu'il fait?",
    back: "Retour",
    preliminary: "Estimation préliminaire",
    planning: "fourchette indicative",
    factorsTitle: "Ce qui influence le prix final",
    factors: [
      "Le modèle exact et la qualité de pièce disponible",
      "L'étendue des dommages à l'intérieur de l'appareil",
      "La disponibilité des pièces et les prix fournisseurs de la semaine",
      "Tout problème supplémentaire découvert à l'inspection gratuite",
    ],
    disclaimer: "Ceci est une fourchette préliminaire et non contraignante. Les pièces, le modèle exact, le diagnostic et la disponibilité peuvent changer le prix final — toujours confirmé avec vous avant tout travail.",
    call: "Appeler",
    text: "Texter cette estimation",
    email: "Écrire à la boutique",
    startOver: "Recommencer",
    visitShop: "Visiter la boutique",
    categories: {
      iphone: { label: "iPhone", blurb: "Toutes les générations, de l'iPhone 8 aux derniers modèles Pro." },
      android: { label: "Téléphone Android", blurb: "Samsung, Google Pixel et autres appareils Android." },
      tablet: { label: "Tablette", blurb: "iPad et tablettes Android de toutes tailles." },
      laptop: { label: "Portable", blurb: "MacBook et portables Windows, matériel et logiciel." },
    },
    tiers: {
      iphone: {
        older: { label: "iPhone ancien", hint: "iPhone 8, X et génération SE" },
        recent: { label: "iPhone récent", hint: "Génération iPhone 11 à 14" },
        newest: { label: "iPhone récent / Pro", hint: "iPhone 15 à 17 et modèles Pro" },
      },
      android: {
        standard: { label: "Android standard", hint: "Téléphones d'entrée et milieu de gamme" },
        recent: { label: "Android récent", hint: "Modèles récents courants" },
        flagship: { label: "Android haut de gamme", hint: "Galaxy S / Ultra, Pixel Pro et similaires" },
      },
      tablet: {
        standard: { label: "Tablette standard", hint: "Tablettes courantes et anciennes" },
        recent: { label: "Tablette récente", hint: "Modèles iPad et Android récents" },
        pro: { label: "Tablette Pro", hint: "iPad Pro et grandes tablettes haut de gamme" },
      },
      laptop: {
        standard: { label: "Portable standard", hint: "Portables courants et anciens" },
        recent: { label: "Portable récent", hint: "Modèles récents courants et ultrabooks" },
        pro: { label: "Portable jeu / Pro", hint: "Portables de jeu, MacBook Pro et stations de travail" },
      },
    },
    issues: {
      screen: { label: "Écran brisé", hint: "Fissures, pixels morts ou problèmes tactiles" },
      battery: { label: "Remplacement de batterie", hint: "Décharge rapide, extinctions, gonflement" },
      charging: { label: "Problème de charge", hint: "Port lâche, ne charge pas ou charge intermittente" },
      backglass: { label: "Vitre arrière brisée", hint: "Vitre arrière fissurée ou boîtier endommagé" },
      camera: { label: "Problème de caméra", hint: "Lentille endommagée, mise au point ou module défectueux" },
      water: { label: "Dégâts d'eau", hint: "Contact avec l'eau, corrosion ou ne s'allume plus" },
      software: { label: "Problème logiciel", hint: "Plantages, mises à jour, démarrage ou comptes" },
      data: { label: "Récupération de données", hint: "Photos, fichiers ou accès à l'appareil" },
    },
    smsBody: "Bonjour Next-G, j'appelle pour une réparation. Appareil : {device}. Problème : {issue}.",
    emailSubject: "Demande de réparation — Next-G",
    resultTitle: "C'est noté — il ne reste qu'à appeler.",
    callNow: "Appeler",
    callLead: "Chaque réparation est différente : on vous chiffre en direct plutôt que de deviner en ligne. Appelez avec ces détails et vous aurez une réponse franche immédiatement.",
    readyTitle: "À avoir sous la main en appelant",
    ready: ["Votre modèle exact, si vous le connaissez", "Ce que fait — ou ne fait plus — l'appareil", "Quand le problème a commencé"],
    noPrice: "Rien ne commence sans votre accord. Le prix annoncé au téléphone est celui que vous acceptez.",
  },
  footer: {
    explore: "Explorer",
    talk: "Nous joindre",
    hours: "Heures",
    quote: "Estimation",
    rights: "Calgary, Alberta",
    line: "Sans rendez-vous bienvenus · Estimations confirmées avant tout travail",
    motto: "Un service nouvelle génération pour la nouvelle génération.",
  },
};
